import { createSlice } from "@reduxjs/toolkit"

export const vendorAnalyticsListSlice = createSlice({
	name: "vendorAnalytics",
	initialState: {
		vendorAnalytics: "",
		errors: [],
	},

	reducers: {
        getVendorAnalytics: (state, action) => {
            // console.log(action.payload);
			state.vendorAnalytics = action.payload
		},
		getVendorAnalyticsList: (state, action) => {
            
			state.vendorAnalytics = action.payload
		},
		getErrors: (state, action) => {
			state.errors = action.payload
		},
	},
})
export const {getVendorAnalytics, getVendorAnalyticsList, getErrors} = vendorAnalyticsListSlice.actions

export default vendorAnalyticsListSlice.reducer

